import { InstantWinApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { INSTANT_WIN_API_URL } = process.env;

export default new InstantWinApi(INSTANT_WIN_API_URL, {}, olyEngineApi);
